import { combineReducers } from "redux";
import {
  dashboard_reducer,
  forgot_password_reducer,
  marketing_reducer,
  notifications_reducer,
  register_reducer,
  reset_password_reducer,
  sessions_reducer,
  select_customer_reducer,
  timezone_reducer,
  user_profile_reducer,
  warrenty_docs_reducer,
  get_delegate_users_reducer,
  create_delegate_user_reducer,
  update_delegate_user_reducer,
} from "./actions/auth";

import {
  add_to_cart_reducer,
  cancel_order_reducer,
  create_order_reducer,
  delete_from_cart_reducer,
  download_pi_reducer,
  export_file_reducer,
  get_addresses_reducer,
  get_cart_reducer,
  get_orders_reducer,
  get_order_reducer,
  get_origins_reducer,
  get_products_reducer,
  get_prod_filters_reducer,
  get_profoma_doc_reducer,
  get_regions_reducer,
  invoice_update_reducer,
  open_orders_reducer,
  open_products_reducer,
  order_add_comments_reducer,
  order_get_comments_reducer,
  order_history_reducer,
  order_repeat_reducer,
  payments_reducer,
  storedOrder_reducer,
  update_cart_reducer,
  update_order_reducer,
  update_profoma_doc_reducer,
  upload_perfoma_doc_reducer,
  clear_cart_reducer,
} from "./actions/orders";
import {
  credit_notes_reducer,
  customer_billing_doc_reducer,
  customer_billing_list_reducer,
  customer_payment_terms_reducer,
  customer_shipments_list_reducer,
  customer_shipment_details_reducer,
  customer_shipment_doc_reducer,
  customer_shipment_terms_reducer,
  customer_shipment_track_reducer,
  get_claims_reducer,
  get_claim_docs_list_reducer,
  get_claim_doc_reducer,
  get_claim_reducer,
  shipment_history_reducer,
  submit_claims_reducer,
  sync_customer_details_reducer,
  sync_customer_orders_reducer,
  customer_on_water_shipment_reducer,
  customer_get_inv_rep_reducer,
} from "./actions/shipmentNPayment";

export default combineReducers({
  auth: combineReducers({
    register: register_reducer,
    sessions: sessions_reducer,
    select_customer: select_customer_reducer,
    forgot_password: forgot_password_reducer,
    reset_password: reset_password_reducer,
    dashboard: dashboard_reducer,
    profile: user_profile_reducer,
    alerts: notifications_reducer,
    delegate_users: get_delegate_users_reducer,
    create_delegate_user: create_delegate_user_reducer,
    update_delegate_user: update_delegate_user_reducer,
    time: timezone_reducer,
  }),
  orders: combineReducers({
    addresses: get_addresses_reducer,
    payments: payments_reducer,
    regions: get_regions_reducer,
    origins: get_origins_reducer,
    products: get_products_reducer,
    inv_rep: customer_get_inv_rep_reducer,
    storedOrder: storedOrder_reducer,
    addToCart: add_to_cart_reducer,
    cart: get_cart_reducer,
    createOrder: create_order_reducer,
    delFromCart: delete_from_cart_reducer,
    all: get_orders_reducer,
    single: get_order_reducer,
    update_cart: update_cart_reducer,
    product_filters: get_prod_filters_reducer,
    update_order: update_order_reducer,
    order_history: order_history_reducer,
    order_repeat: order_repeat_reducer,
    order_add_comments: order_add_comments_reducer,
    order_get_comments: order_get_comments_reducer,
    profoma_doc: get_profoma_doc_reducer,
    update_profoma_doc: update_profoma_doc_reducer,
    open_orders: open_orders_reducer,
    open_prods: open_products_reducer,
    invoice_update: invoice_update_reducer,
    upload_perfoma_doc: upload_perfoma_doc_reducer,
    download_pi: download_pi_reducer,
    order_cancel: cancel_order_reducer,
    export_product: export_file_reducer,
    clear_cart: clear_cart_reducer,
  }),
  shipNPay: combineReducers({
    customer_shipments_list: customer_shipments_list_reducer,
    customer_payment_terms: customer_payment_terms_reducer,
    customer_shipment_terms: customer_shipment_terms_reducer,
    customer_shipment_doc: customer_shipment_doc_reducer,
    customer_billing_doc: customer_billing_doc_reducer,
    customer_billing_list: customer_billing_list_reducer,
    customer_shipment_track: customer_shipment_track_reducer,
    customer_shipment_details: customer_shipment_details_reducer,
    sync_customer_orders: sync_customer_orders_reducer,
    sync_customer_details: sync_customer_details_reducer,
    shipment_history: shipment_history_reducer,
    on_water_report: customer_on_water_shipment_reducer,
  }),
  claims: combineReducers({
    get_claims: get_claims_reducer,
    create: submit_claims_reducer,
    txns: credit_notes_reducer,
    details: get_claim_reducer,
    claim_doc: get_claim_doc_reducer,
    claim_doc_list: get_claim_docs_list_reducer,
  }),
  marketings: marketing_reducer,
  warrenty_docs: warrenty_docs_reducer,
});
